/** Load onnxruntime-web and create inference sessions (WebGPU → WASM). */

const ORT_VERSION = "1.22.0";
const CDN = `https://cdn.jsdelivr.net/npm/onnxruntime-web@${ORT_VERSION}/dist/`;

let ortMod = null;

export async function loadOrt() {
  if (ortMod) return ortMod;
  const sources = [
    { url: `${CDN}ort.webgpu.min.mjs`, wasm: CDN },
    { url: `${CDN}ort.min.mjs`, wasm: CDN },
  ];
  for (const s of sources) {
    try {
      ortMod = await import(/* @vite-ignore */ s.url);
      ortMod.env.wasm.wasmPaths = s.wasm;
      return ortMod;
    } catch {
      /* try next */
    }
  }
  throw new Error("Could not load onnxruntime-web");
}

export async function createSession(modelUrl, options = {}) {
  const ort = await loadOrt();
  const hasGpu = !!globalThis.navigator?.gpu;
  const forcedEp = options.ep || options.executionProvider || null;
  console.log(`[ort] createSession ${modelUrl} secure=${globalThis.isSecureContext} navigator.gpu=${hasGpu} forcedEp=${forcedEp || "auto"}`);
  const providers = forcedEp ? [forcedEp] : (hasGpu ? ["webgpu", "wasm"] : ["wasm"]);
  const resp = await fetch(modelUrl);
  if (!resp.ok) throw new Error(`fetch model ${modelUrl}: ${resp.status} ${resp.statusText}`);
  const buf = await resp.arrayBuffer();
  console.log(`[ort] fetched ${modelUrl} bytes=${buf.byteLength}`);
  for (const ep of providers) {
    try {
      const session = await ort.InferenceSession.create(buf, { executionProviders: [ep] });
      console.log(`[ort] using EP ${ep} for ${modelUrl}`);
      return { session, ort, ep };
    } catch (e) {
      console.warn(`[ort] EP ${ep} failed for ${modelUrl}: ${e?.message || e?.stack || String(e)}`);
    }
  }
  throw new Error(`No execution provider for ${modelUrl}`);
}
